<template>
<section class="wrapper">
    <section>
        <swiper
            class="swiper model_slide"
            :options="imgSwiperOption"
        >
            <swiper-slide class="item" v-for="(att, idx) in atts" :key="idx">
                <div class="item">
                    <div class="model_img">
                        <img :src="att.url">
                    </div>
                </div>
            </swiper-slide>

            <div class="swiper-pagination" slot="pagination"></div>

        </swiper>

        

        <div class="wrap" style="padding-top:20px">
            <div class="find_showroom_info" style="margin-top:0">
                <dl class="showroom_info">
                    <dt>
                        {{ shopItem.name }}
                        <div><img :src="shopItem.brandAtt ? shopItem.brandAtt.url : ''"></div>
                    </dt>
                    <dd>
                        <span>{{ (shopItem.dealer) ? shopItem.dealer.name : '' }}</span>
                        <p>{{ shopItem.addr }}</p>
                    </dd>
                </dl>
            </div>
            <div class="consultant_introduce">
                <!--<h4 class="title">소개</h4>-->
                <div class="contants">
                    <div class="contants_pbox">
                        <p>{{shopItem.content}}</p>
                    </div>
                </div>
            </div>
            
            <ReviewData
                v-if="Object.keys(shopItem).length"
                v-bind="shopItem.reviewScore"
                type-shop>
            </ReviewData>

            <ReviewList 
                :items="$store.state.review.items" 
                :totalCount="$store.state.review.totalCount"
                :to="`/shopReview/${shopItem.id}`">
            </ReviewList>

        </div>
    </section>
    
    <section class="freebook_consultant showroom_consultant " v-show="scOnload">

        <div class="wrap">
            <h2 class="section_title" @click="$router.push(`/shopSc/${shopItem.id}`);">
                소속 컨설턴트 
                <a><img :src="resource.imgIconArrowRigth"></a>
                <!-- <router-link :to="`/shopSc/${shopItem.id}`"><img :src="resource.imgIconArrowRigth"></router-link> -->
            </h2>
        </div>

        <swiper
            class="swiper freebook_consultant_ul mh11 mh11"
            :options="scSwiperOption"
        >
            <swiper-slide class="item" v-for="(sc, idx) in scItems" :key="idx">
                <router-link class="carousel-shadow" :to="`/scInfo/${sc.id}`">
                    <figure class="consultant_img">
                        <!-- <span v-if="sc.certificationYn == 'Y'">
                                <img :src="resource.imgIconCertified" style="position: unset;">인증
                            </span> -->
                        <img :src=" sc.attUrl ? sc.attUrl : resource.imgSampleConsultant">
                        <dl>
                            <dt>{{sc.name}}</dt>
                            <dd>{{ sc.shopName  }} - {{ sc.dealerName }}</dd>
                        </dl>
                    </figure>
                    <!--
                    <figcaption>
                        <div class="name">
                            <span>{{ sc.name }}</span>
                            <span v-if="sc.certificationYn == 'Y'">
                                <img :src="resource.imgIconCertified3">인증
                            </span>
                        </div>
                        <div class="social ">
                            <span><img :src="resource.imgIconGood">{{ sc.good }}</span>
                            <span><img :src="resource.imgIconMessage">{{ sc.reviewCount }}</span>
                        </div>
                    </figcaption>
                    -->
                </router-link>


            </swiper-slide>
        </swiper>
        
    </section>

    
    <div class="wrap">
        <section class="showroom_time" v-if="$store.state.common.onload">
            <h2 class="section_title">위치 및 영업시간</h2>

            <div class="map_wrap">
                <div class="mapMask"></div>
                <KakaoMap style="width:100%; height:200px; padding:0px;"
                    ref="kakaoMap"
                    :lat="shopItem.lat"
                    :har="shopItem.har"
                ></KakaoMap>
                <div v-if="shopItem.shopBusinessDefault">
                    <h4>영업시간</h4>
                    <ul>
                        <li>
                            <span>평상시 : {{shopItem.shopBusinessDefault.startTime}} ~ {{shopItem.shopBusinessDefault.endTime}}</span>
                        </li>
                    </ul>
                    <!-- <ul>
                        <li><span>평일 : 09:00 ~ 20:00</span></li>
                        <li><span>토요일 : 10:00 ~ 20:00</span></li>
                        <li><span>일요일 : 10:00 ~ 20:00</span></li>
                        <li><span>공휴일 : 10:00 ~ 20:00</span></li>
                    </ul> -->
                </div>
            </div>
        </section>
    </div>
    

</section>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import ReviewData from '../../components/review/ReviewData.vue';
import ReviewList from '../../components/review/ReviewList.vue';
import KakaoMap from '../../components/map/KakaoMap.vue';

export default {
    name:'ShopInfo',
    components:{
        ReviewData,
        ReviewList,
        KakaoMap
    },
    data() {
        return {
            imgSwiperOption: {
                autoHeight: true, //enable auto height
                pagination: {
                    el: '.swiper-pagination'
                }
            },
            scSwiperOption: {
                autoHeight: true, //enable auto height
                slidesPerView: 2.4, //화면에 slide 노출 개수
            },

            scOnload: false,
            atts:[],
        }
    },
    computed: {
        ...mapState({
            brandItems: state => state.brand.items,
            shopItem: state => state.shop.item,
            scItems: state => state.sc.items,
            resource: state => state.resource,

            orderby: state => state.orderby,
            sort: state => state.sort,
        }),
        ...mapGetters([
            'viewShopAtts'
        ]),
        shopId() { return this.$route.params.shopId; }
    },
    async created() {
        this.$store.state.headerBlank = false;

        await this.$store.dispatch('GET_SHOP', this.shopId)
        .then(() => {
            this.atts = this.viewShopAtts(this.shopItem.atts);
            this.$store.commit('SHOW_ONLOAD');
        })
        .catch((e)=>{
            this.$store.commit('SHOW_ONLOAD');
            this.apiCatch(e);
        })

        this.$store.dispatch('GET_REVIEW_LIST_PAGE', {shopId: this.shopId, hasContent: 1, size: 5});
        this.$store.dispatch('GET_SC_LIST_PAGE', { shopId: this.shopId, size:5, orderby:this.orderby.RANDOM })

        this.scOnload = true;
    },
    methods: {
        getRateGood(data) {
            return this.$_getRateGood(data.good, data.normal, data.bad)
        },
    }
    
}
</script>

<style>
.free_book_data .title {
    display:none
}

.freebook_consultant_ul .item a figure>img {
    animation: none !important;
}

</style>